<template>
    <div style="padding:20px;background:#e9ecf3;">
        <div style="display: flex;margin-bottom: 10px;">
            <div style="flex:1;margin: 0 5px;overflow: hidden;">
                <el-card class="box-card" shadow="hover" style="color: gray;" :style="{height: '100%'}">
                    <el-descriptions class="margin-top" title="营业" :column="3" size="mini" border>
                        <el-descriptions-item label="实收">￥0.00</el-descriptions-item>
                        <el-descriptions-item label="未结账">0.00</el-descriptions-item>
                        <el-descriptions-item label="销售">0.00</el-descriptions-item>
                        <el-descriptions-item label="前一日实收">0.00</el-descriptions-item>
                        <el-descriptions-item label="前一日销售">0.00</el-descriptions-item>
                        <el-descriptions-item label="人数">0.00</el-descriptions-item>
                        <el-descriptions-item label="人均">0.00</el-descriptions-item>
                        <el-descriptions-item label="台数">0.00</el-descriptions-item>
                        <el-descriptions-item label="台均">0.00</el-descriptions-item>
                        <el-descriptions-item label="外卖">0.00</el-descriptions-item>
                        <el-descriptions-item label="餐均">0.00</el-descriptions-item>
                        <el-descriptions-item label="均餐时间">0分钟</el-descriptions-item>
                        <el-descriptions-item label="翻台率">0%</el-descriptions-item>
                    </el-descriptions>
                </el-card>
            </div>
            <div style="flex:1;margin: 0 5px;overflow: hidden;">
                <el-card class="box-card" shadow="hover" style="color: gray;" :style="{height: '100%'}">
                    <div slot="header" class="clearfix" style="display: flex;align-items: center;">
                        <span style="flex:1;">餐段统计</span>
                        <el-button size="mini" type="success" icon="el-icon-refresh"></el-button>
                    </div>
                    <div style="display: flex;line-height: 21px;padding: 10px 0;border-bottom: 1px solid #ddd;">
                        <div style="flex:1;">早市</div>
                        <div>
                            <span style="color: black;font-weight: bold;font-size: 18px;">0</span>
                            台
                        </div>
                    </div>
                    <div style="display: flex;line-height: 21px;padding: 10px 0;border-bottom: 1px solid #ddd;">
                        <div style="flex:1;">午市</div>
                        <div>
                            <span style="color: black;font-weight: bold;font-size: 18px;">0</span>
                            台
                        </div>
                    </div>
                    <div style="display: flex;line-height: 21px;padding: 10px 0;">
                        <div style="flex:1;">晚市</div>
                        <div>
                            <span style="color: black;font-weight: bold;font-size: 18px;">0</span>
                            台
                        </div>
                    </div>
                </el-card>
            </div>
            <div style="flex:2;margin: 0 5px;height: 276.5px;overflow: hidden;">
                <el-card class="box-card flexcard" shadow="hover"
                    style="height: 100%;display: flex;flex-direction: column;">
                    <div slot="header" class="clearfix">
                        <span>近期营业趋势</span>
                        <div style="float: right; padding: 3px 0">
                            <el-button size="mini" @click="显示图(7)" plain style="margin-bottom: 0;">7天</el-button>
                            <el-button size="mini" @click="显示图(30)" plain style="margin-bottom: 0;">30天</el-button>
                            <el-button size="mini" type="success" icon="el-icon-refresh"></el-button>
                        </div>
                    </div>
                    <div style="flex:1;padding: 0;">
                        <ve-histogram :data="chartData" :settings="chartSettings" :extend="extend"
                            :legend-visible='false' height='100%'></ve-histogram>
                    </div>
                </el-card>
            </div>
        </div>
        <div style="display: flex;margin-bottom: 10px;">
            <div style="flex:1;margin: 0 5px;overflow: hidden;">
                <el-card class="box-card" shadow="hover" style="color: gray;">
                    <div slot="header" class="clearfix" style="display: flex;align-items: center;">
                        <span style="flex:1;">商品销售额</span>
                        <el-button @click="库存缺货预警()" size="mini" type="success" icon="el-icon-refresh"></el-button>
                    </div>
                    <div style="flex:1;padding: 0;overflow: auto;">
                        <u-table v-loading="缺货商品loading" :data="缺货商品list"
                            :default-sort="{ prop: 'F_可用库存', order: 'ascending' }" style="flex:1;" height="200" use-virtual
                            showBodyOverflow="tooltip" showHeaderOverflow="tooltip" :row-height="57" stripe
                            :header-row-class-name="'dddhead'">
                            <!-- 原材料 -->
                            <u-table-column sortable prop="C_原材料编号" label="销售金额">
                            </u-table-column>
                            <!-- <u-table-column prop="C_规格" label="规格"></u-table-column> -->
                            <u-table-column sortable prop="F_可用库存" label="退货金额" align="right">
                                <template slot-scope="scope">
                                    <el-tooltip effect="dark"
                                        :content="(scope.row.F_库存数量 - scope.row.F_销售锁定) + scope.row.C_单位"
                                        placement="top-end">
                                        <div style="color:red;font-weight: bold;">
                                            {{ $dw(scope.row.J_单位换算, (scope.row.F_库存数量 - scope.row.F_销售锁定), scope.row.C_单位) }}
                                        </div>
                                    </el-tooltip>
                                </template>
                            </u-table-column>
                            <u-table-column sortable prop="F_库存下限" label="赠送金额" align="right">
                                <template slot-scope="scope">
                                    <el-tooltip effect="dark" :content="scope.row.F_近7天销量 * 2 + scope.row.C_单位"
                                        placement="top-end">
                                        <div>{{ $dw(scope.row.J_单位换算, scope.row.F_近7天销量 * 2, scope.row.C_单位) }}</div>
                                    </el-tooltip>
                                </template>
                            </u-table-column>
                            <u-table-column sortable prop="C_原材料编号" label="反结后退货金额">
                            </u-table-column>
                            <u-table-column sortable prop="C_原材料编号" label="反结后赠送金额">
                            </u-table-column>
                            <!-- <u-table-column sortable prop="F_库存下限" label="库存下限" align="right">
                                <template slot-scope="scope">
                                    <el-tooltip effect="dark" :content="scope.row.F_库存下限+scope.row.C_单位" placement="top-end">
                                        <div>{{$dw(scope.row.J_单位换算,scope.row.F_库存下限,scope.row.C_单位)}}</div>
                                    </el-tooltip>
                                </template>
                            </u-table-column> -->
                        </u-table>
                    </div>
                </el-card>
            </div>
            <div style="flex:1;margin: 0 5px;overflow: hidden;">
                <el-card class="box-card" shadow="hover" style="color: gray;">
                    <div slot="header" class="clearfix" style="display: flex;align-items: center;">
                        <span style="flex:1;">会员</span>
                        <span style="flex: 1;">新增会员:0</span>
                        <span style="flex: 1;">充值金额:0(本金:0,赠送:0)</span>

                        <el-button @click="库存过剩预警()" size="mini" type="success" icon="el-icon-refresh"></el-button>
                    </div>
                    <div style="flex:1;padding: 0;overflow: auto;">
                        <u-table v-loading="过剩商品loading" :data="过剩商品list" title="充值收款明细"
                            :default-sort="{ prop: 'F_可用库存', order: 'descending' }" style="flex:1;" height="200" use-virtual
                            showBodyOverflow="tooltip" showHeaderOverflow="tooltip" :row-height="57" stripe
                            :header-row-class-name="'dddhead'">
                            <u-table-column sortable prop="C_原材料编号" label="付款方式"></u-table-column>
                            <u-table-column sortable prop="F_可用库存" label="充值次数"></u-table-column>
                            <u-table-column sortable prop="F_库存上限" label="充值金额" align="right"></u-table-column>
                        </u-table>
                    </div>
                </el-card>
            </div>
        </div>
        <div style="display: flex;margin-bottom: 10px;">
            <div style="flex:1;margin: 0 5px;overflow: hidden;">
                <el-card class="box-card" shadow="hover" style="color: gray;">
                    <div slot="header" class="clearfix" style="display: flex;align-items: center;">
                        <span>总收款:0</span>
                        <el-link type="primary" style="margin-left: 10px;" :underline="false">收款方式</el-link>
                        <el-link type="" :underline="false" style="margin-left: 5px;">员工姓名</el-link>
                        
                        <!-- <el-button size="mini" type="success" icon="el-icon-refresh" @click="on近30日商品统计()"></el-button> -->
                    </div>
                    <div style="flex:1;padding: 0;overflow: auto;">
                        <u-table v-loading="商品销量loading" :data="过滤近30日商品统计list"
                            :default-sort="{ prop: 'F_金额', order: 'descending' }" style="flex:1;" height="200" use-virtual
                            showBodyOverflow="tooltip" showHeaderOverflow="tooltip" :row-height="57" stripe
                            :header-row-class-name="'dddhead'">
                            <u-table-column sortable prop="C_原材料编号" label="收款方式" />
                            <u-table-column sortable prop="C_原材料编号" label="收款次数" />
                            <u-table-column sortable prop="C_原材料编号" label="收款金额" />
                        </u-table>
                    </div>
                </el-card>
            </div>
            <div style="flex:1;margin: 0 5px;overflow: hidden;">
                <el-card class="box-card" shadow="hover" style="color: gray;">
                    <div slot="header" class="clearfix" style="display: flex;align-items: center;">
                        <span>营业收款:0</span>
                        <el-link type="primary" style="margin-left: 10px;" :underline="false">收款方式</el-link>
                        <el-link type="" :underline="false" style="margin-left: 5px;">员工姓名</el-link>
                        
                        <!-- <el-button size="mini" type="success" icon="el-icon-refresh" @click="on近30日商品统计()"></el-button> -->
                    </div>
                    <div style="flex:1;padding: 0;overflow: auto;">
                        <u-table v-loading="商品销量loading" :data="过滤近30日商品统计list"
                            :default-sort="{ prop: 'F_金额', order: 'descending' }" style="flex:1;" height="200" use-virtual
                            showBodyOverflow="tooltip" showHeaderOverflow="tooltip" :row-height="57" stripe
                            :header-row-class-name="'dddhead'">
                            <u-table-column sortable prop="C_原材料编号" label="收款方式" />
                            <u-table-column sortable prop="C_原材料编号" label="收款次数" />
                            <u-table-column sortable prop="C_原材料编号" label="收款金额" />
                        </u-table>
                    </div>
                </el-card>
            </div>
            <div style="flex:1;margin: 0 5px;overflow: hidden;">
                <el-card class="box-card" shadow="hover" style="color: gray;">
                    <div slot="header" class="clearfix" style="display: flex;align-items: center;">
                        <span>会员储值收款:0</span>
                        <el-link type="primary" style="margin-left: 10px;" :underline="false">收款方式</el-link>
                        <el-link type="" :underline="false" style="margin-left: 5px;">员工姓名</el-link>
                        
                        <!-- <el-button size="mini" type="success" icon="el-icon-refresh" @click="on近30日商品统计()"></el-button> -->
                    </div>
                    <div style="flex:1;padding: 0;overflow: auto;">
                        <u-table v-loading="商品销量loading" :data="过滤近30日商品统计list"
                            :default-sort="{ prop: 'F_金额', order: 'descending' }" style="flex:1;" height="200" use-virtual
                            showBodyOverflow="tooltip" showHeaderOverflow="tooltip" :row-height="57" stripe
                            :header-row-class-name="'dddhead'">
                            <u-table-column sortable prop="C_原材料编号" label="收款方式" />
                            <u-table-column sortable prop="C_原材料编号" label="收款次数" />
                            <u-table-column sortable prop="C_原材料编号" label="充值金额" />
                        </u-table>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    computed: {
        ...mapState(['当前登录员工', '加载完成', '当前门店', '当前操作员', '当前公司', '当前仓库', '近30日商品销量list', '商品list', '商品类别list', '配送线路list']),
        缺货商品list() {
            return this.商品list.Where(a => a.I_上架 && a.F_可用库存 <= (a.F_近7天销量 * 2));
        },
        过剩商品list() {
            return this.商品list.Where(a => a.I_上架 && a.F_库存上限 > 0 && a.F_可用库存 >= a.F_库存上限);
        },
        过滤近30日商品统计list() {
            let list = this.近30日商品统计list;
            if (this.近30日商品统计条件.C_品牌) list = list.Where(a => (a.C_品牌 || '').includes(this.近30日商品统计条件.C_品牌));
            if (this.近30日商品统计条件.C_商品类别编号) list = list.Where(a => a.C_商品类别编号 == this.近30日商品统计条件.C_商品类别编号);
            return list;
        }
    },
    data() {
        this.chartSettings = {
            labelMap: {
                '日': '日期',
                '单据数': '单据数',
            },
        };
        this.extend = {
            grid: {
                x: 10,
                y: 20,
                x2: 10,
                y2: 10,
            },
            tooltip: {
                triggerOn: "mousemove",
                show: true,
                trigger: 'axis',
            },
            series: {
                label: {
                    normal: {
                        show: true,
                        rotate: 90,
                        color: '#fff',
                    },
                }
            }
        };
        return {
            订货单统计list: [],
            chartData: {
                columns: ['日', '单据数'],
                rows: [],
            },
            日统计: [],
            近30日商品统计list: [],
            近30日客户统计list: [],
            近30日商品统计条件: {
                C_品牌: '',
                C_商品类别编号: '',
            },
            近30日客户统计: '',

            商品销量loading: false,
            客户销量loading: false,

            缺货商品loading: false,
            过剩商品loading: false,
        }
    },
    async mounted() {
        try {
            await this.$wait('加载完成', 60 * 1000);

            if (this.当前门店.I_门店Id == '0') {
                this.近30日商品统计条件 = [];
                this.近30日客户统计 = [];
            }

            //this.on近30日商品统计();
            //this.on近30日客户统计();
        } catch (error) {
            this.$Alert(error);
        }
    },
    methods: {
        async 库存缺货预警() {
            this.缺货商品loading = true;
            try {
                await this.获取商品(false);
            } catch (error) {
                this.$Alert(error);
            } finally {
                this.缺货商品loading = false;
                this.过剩商品loading = false;
            }
        },
        async 库存过剩预警() {
            this.过剩商品loading = true;
            try {
                await this.获取商品(false);
            } catch (error) {
                this.$Alert(error);
            } finally {
                this.缺货商品loading = false;
                this.过剩商品loading = false;
            }
        },
        async 库存缺货导出() {
            try {
                let data = [];
                this.缺货商品list.forEach(e => {
                    data.push({
                        原材料名称: this.bhtoname(this.原材料list, 'C_原材料名称', 'C_原材料编号', e.C_原材料编号),
                        商品类别编号: e.C_商品类别编号,
                        商品编号: e.C_商品编号,
                        商品名称: e.C_商品名称,
                        品牌: e.C_品牌,
                        商品类型: e.C_商品类型,
                        规格: e.C_规格,
                        单位: e.C_单位,
                        库存上限: e.F_库存上限,
                        库存下限: e.F_库存下限,
                        可用库存: e.F_可用库存,
                    });
                });
                this.jsonToExcell(data, '库存缺货')
            } catch (error) {
                this.$Alert(error);
            }
        },
        async 库存过剩导出() {
            try {
                let data = [];
                this.缺货商品list.forEach(e => {
                    data.push({
                        原材料名称: this.bhtoname(this.原材料list, 'C_原材料名称', 'C_原材料编号', e.C_原材料编号),
                        商品类别编号: e.C_商品类别编号,
                        商品编号: e.C_商品编号,
                        商品名称: e.C_商品名称,
                        品牌: e.C_品牌,
                        商品类型: e.C_商品类型,
                        规格: e.C_规格,
                        单位: e.C_单位,
                        库存上限: e.F_库存上限,
                        库存下限: e.F_库存下限,
                        可用库存: e.F_可用库存,
                    });
                });
                this.jsonToExcell(data, '库存过剩')
            } catch (error) {
                this.$Alert(error);
            }
        },
        async 显示图(天数 = 7) {
            this.chartData.rows = [];
            for (let index = (天数 - 1); index >= 0; index--) {
                let tmp = new Date().addDays(-index);
                let tmp统计 = this.日统计.FirstOrDefault(a => new Date(a.日期).format('yyyy/MM/dd') == tmp.format('yyyy/MM/dd'));
                this.chartData.rows.push({
                    日: tmp.getDate(),
                    单据数: (tmp统计 || {}).数量 || 0,
                });
            }
        },
        async on导出excell() {
            try {
                this.jsonToExcell([{ "姓名": "张三", "年龄": "12" }, { "姓名": "李四", "年龄": "18" }])
            } catch (error) {
                this.$Alert(error);
            }
        },
        async on导入(file) {
            try {
                let that = this;
                let reader = new FileReader()
                reader.readAsDataURL(file.raw)
                reader.onload = async function (event) {
                    let img_base64 = this.result;
                    let tmpjson = await that.excelToJSON({ content: img_base64 });
                }
            } catch (error) {
                this.$Alert(error);
            }
        },
        toDHD(name) {
            this.$router.push('/main/dd/dhd?lx=' + name);
            if (window.settabname) window.settabname(name);
        },
        async on近30日商品统计导出() {
            try {
                let data = [];
                this.近30日商品统计list.forEach(e => {
                    data.push({
                        原材料名称: this.bhtoname(this.原材料list, 'C_原材料名称', 'C_原材料编号', e.C_原材料编号),
                        商品类别编号: e.C_商品类别编号,
                        商品编号: e.C_商品编号,
                        商品名称: e.C_商品名称,
                        品牌: e.C_品牌,
                        规格: e.C_规格,
                        单位: e.C_单位,
                        数量: this.$dw(e.J_单位换算, (e.F_数量), e.C_单位),
                        金额: e.F_金额.toFixed(2),
                    });
                });
                this.jsonToExcell(data, '近30日商品统计')
            } catch (error) {
                this.$Alert(error);
            }
        },
        async on近30日客户统计导出() {
            try {
                let data = [];
                this.近30日客户统计list.forEach(e => {
                    data.push({
                        原材料名称: this.bhtoname(this.原材料list, 'C_原材料名称', 'C_原材料编号', e.C_原材料编号),
                        数量: e.F_数量,
                        金额: e.F_金额.toFixed(2),
                    });
                });
                this.jsonToExcell(data, '近30日商品统计')
            } catch (error) {
                this.$Alert(error);
            }
        },
        品牌querySearch(queryString, cb) {
            let list = this.商品list;
            let 品牌list = list.Select('$.C_品牌').GroupBy('$', null, key => { return { value: key } });
            if (queryString) 品牌list = 品牌list.Where(a => (a.value || '').includes(queryString));
            cb(品牌list);
        },
        ...mapMutations(['setobj', 'setarr', 'setvalue', 'setobjarr', 'setobjvalue', 'setobjobj', 'cleararr', 'clearobjarr']),
        ...mapActions(['获取商品类别', '获取客户', '获取商品', '获取仓库', '获取原材料']),
    }
}
</script>

<style lang="scss">
.flexcard .el-card__body {
    flex: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
}
</style>